import { IPurchasingGroupResponsibilityOccupationDto } from '../types/purchasing-group-responsibility-occupation.dto';

export class PurchasingGroupResponsibilityOccupation {
    public readonly companyCodeId: string;
    public readonly materialGroupId: string;
    public readonly ownerPurchasingGroupId: string;
    public readonly ownerPurchasingGroupCode: string;
    public readonly ownerPurchasingGroupName: string;

    constructor(dto: IPurchasingGroupResponsibilityOccupationDto) {
        this.companyCodeId = dto.companyCodeId;
        this.materialGroupId = dto.materialGroupId;
        this.ownerPurchasingGroupId = dto.ownerPurchasingGroupId;
        this.ownerPurchasingGroupCode = dto.ownerPurchasingGroupCode;
        this.ownerPurchasingGroupName = dto.ownerPurchasingGroupName;
    }
}
